/**
 * Product Aroma Bars — animation au scroll (barres visibles sans JS).
 * Rejoue à chaque entrée dans l'écran ; remet à zéro à la sortie
 * (ne se remplit jamais hors écran, et l'effet rejoue si on revient en arrière).
 */
(function () {
  'use strict';

  var container = document.getElementById('aroma-bars-list');
  if (!container) return;

  var bars = container.querySelectorAll('.aroma-bar');
  var fills = container.querySelectorAll('.aroma-bar__fill');

  function show() {
    bars.forEach(function (bar) { bar.classList.add('visible'); });
    fills.forEach(function (fill) { fill.classList.add('animated'); });
  }
  function hide() {
    bars.forEach(function (bar) { bar.classList.remove('visible'); });
    fills.forEach(function (fill) { fill.classList.remove('animated'); });
  }

  if (!('IntersectionObserver' in window)) {
    show();
    return;
  }

  // Déclenche quand les barres entrent vraiment dans l'écran, masque quand elles sortent.
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) show();
        else hide();
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
  );

  observer.observe(container);
})();
